import { api } from '../utils/api';

// Scraper-related API calls
export const fetchHtml = (url) => {
    return api.post('/api/selectors/fetch-html', { url });
};

export const suggestSelectors = (htmlContent) => {
    return api.post('/api/selectors/suggest', { html_content: htmlContent });
};

/**
 * Fetch paginated executions (used by the monitoring UI).
 * Accepts an object with { page, pageSize, jobId, status, ...otherFilters }.
 * Maps frontend field names to backend query params and returns parsed JSON.
 */
export const fetchJobs = ({ page = 1, pageSize = 25, jobId, status, ...rest } = {}) => {
    const params = {
        page,
        page_size: pageSize,
        // Map frontend filter names to backend expected params
        ...(jobId ? { job_id: jobId } : {}),
        ...(status ? { status } : {}),
        ...rest
    };
    return api.get('/api/executions', { params }).then(res => res.data);
};

/**
 * Delete jobs by IDs.
 * Calls DELETE /api/jobs with JSON body { ids: [...] }.
 * Axios supports sending a request body with DELETE via the `data` config.
 * Returns the axios promise (resolves on 2xx, rejects otherwise).
 */
export const deleteJobs = (ids) => {
    if (!Array.isArray(ids)) {
        throw new Error('deleteJobs expects an array of ids');
    }
    return api.delete('/api/jobs', { data: { ids } });
};